import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import EnhancedBlogEditor from "../admin/Components/EnhancedBlogEditor";

const API_HOST = process.env.REACT_APP_API_URL;

const CreateBlog = () => {
  const navigate = useNavigate();
  const [title, setTitle] = useState("");
  const [creator, setCreator] = useState("");
  const [content, setContent] = useState(null);
  const [excerpt, setExcerpt] = useState("");
  const [homeImage, setHomeImage] = useState(null);
  const [tags, setTags] = useState([]);
  const [categories, setCategories] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Fetch current user's name on component mount
  useEffect(() => {
    const getCurrentUserName = async () => {
      const authToken = sessionStorage.getItem("authToken");
      if (!authToken) return;

      try {
        const response = await fetch(`${API_HOST}auth/getuser`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "auth-token": authToken,
          },
        });

        if (!response.ok) throw new Error("Failed to fetch user");

        const userData = await response.json();
        const creatorName = userData.name === "creator" || !userData.name ? "Admin" : userData.name;
        setCreator(creatorName);
      } catch (error) {
        console.error("Failed to fetch user:", error);
        setCreator("Blogger");
      }
    };

    getCurrentUserName();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!title || !content || !homeImage) {
      alert("Please fill all required fields and upload an image");
      return;
    }

    setIsSubmitting(true);
    const authToken = sessionStorage.getItem("authToken");
    const formData = new FormData();
    formData.append("title", title);
    formData.append("creator", creator);
    formData.append("content", JSON.stringify(content));
    formData.append("excerpt", excerpt);
    formData.append("homeImage", homeImage);
    formData.append("tags", JSON.stringify(tags));
    formData.append("categories", JSON.stringify(categories));
    formData.append("Hpriority", 0);
    formData.append("Bpriority", 0);
    formData.append("visibility", "private");

    try {
      const response = await axios.post(`${API_HOST}blogs/create`, formData, {
        headers: {
          "auth-token": authToken,
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.status === 201) {
        alert("Blog created successfully!");
        navigate("/blogger/blogs");
      }
    } catch (error) {
      console.error("Error creating blog:", error);
      alert("Failed to create blog. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="container" style={{ padding: "40px 20px", maxWidth: "1200px" }}>
      <div style={{ marginBottom: "30px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <h1>Create New Blog</h1>
        <button onClick={() => navigate("/blogger/blogs")} className="logout-button">
          Back to Blogs
        </button>
      </div>

      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: "20px" }}>
          <label style={{ display: "block", marginBottom: "8px", fontWeight: "bold" }}>
            Title <span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="Enter blog title"
            style={{
              width: "100%",
              padding: "12px",
              fontSize: "16px",
              borderRadius: "4px",
              border: "1px solid #444", background: "#2a2a2a", color: "#fff"
            }}
            required
          />
        </div>

        <div style={{ marginBottom: "20px" }}>
          <label style={{ display: "block", marginBottom: "8px", fontWeight: "bold" }}>
            Excerpt (SEO Description)
          </label>
          <textarea
            value={excerpt}
            onChange={(e) => setExcerpt(e.target.value)}
            placeholder="Enter a brief excerpt for SEO (max 200 characters)"
            maxLength={200}
            rows={3}
            style={{
              width: "100%",
              padding: "12px",
              fontSize: "16px",
              borderRadius: "4px",
              border: "1px solid #444", background: "#2a2a2a", color: "#fff"
            }}
          />
          <small>{excerpt.length}/200 characters</small>
        </div>

        <div style={{ marginBottom: "20px" }}>
          <label style={{ display: "block", marginBottom: "8px", fontWeight: "bold" }}>
            Content <span style={{ color: "red" }}>*</span>
          </label>
          <EnhancedBlogEditor onChange={setContent} />
        </div>

        <div style={{ marginBottom: "20px" }}>
          <label style={{ display: "block", marginBottom: "8px", fontWeight: "bold" }}>
            Home Image <span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="file"
            accept="image/*"
            onChange={(e) => setHomeImage(e.target.files[0])}
            style={{
              width: "100%",
              padding: "12px",
              fontSize: "16px"
            }}
            required
          />
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px", marginBottom: "20px" }}>
          <div>
            <label style={{ display: "block", marginBottom: "8px", fontWeight: "bold" }}>Tags (comma-separated)</label>
            <input
              type="text"
              placeholder="e.g., web development, react, javascript"
              onChange={(e) => setTags(e.target.value.split(",").map(t => t.trim()).filter(Boolean))}
              style={{
                width: "100%",
                padding: "12px",
                fontSize: "16px",
                borderRadius: "4px",
                border: "1px solid #444", background: "#2a2a2a", color: "#fff"
              }}
            />
          </div>

          <div>
            <label style={{ display: "block", marginBottom: "8px", fontWeight: "bold" }}>Categories (comma-separated)</label>
            <input
              type="text"
              placeholder="e.g., technology, tutorials"
              onChange={(e) => setCategories(e.target.value.split(",").map(c => c.trim()).filter(Boolean))}
              style={{
                width: "100%",
                padding: "12px",
                fontSize: "16px",
                borderRadius: "4px",
                border: "1px solid #444", background: "#2a2a2a", color: "#fff"
              }}
            />
          </div>
        </div>

        <div style={{ display: "flex", gap: "10px", marginTop: "30px" }}>
          <button
            type="submit"
            disabled={isSubmitting}
            className="logout-button"
            style={{ flex: 1 }}
          >
            {isSubmitting ? "Creating..." : "Create Blog"}
          </button>
          <button
            type="button"
            onClick={() => navigate("/blogger/blogs")}
            className="logout-button"
            style={{ flex: 1, background: "#6c757d" }}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default CreateBlog;
